module.exports = __webpack_public_path__ + "static/media/pleasure.4972e455.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/pleasure.JPG
// module id = 492
// module chunks = 0